import { TooltipProps } from "recharts";
import { Typography } from "@mui/material";

export const StackedBarChartTooltip = ({
  active,
  payload,
  label,
}: TooltipProps<number, string>) => {
  if (active && payload && payload.length > 0) {
    const getValue = (key: string) =>
      payload.find((p) => p.dataKey === key)?.value ?? 0;

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #ccc",
          padding: 10,
          fontFamily: "Montserrat",
          fontSize: 14,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: "bold", fontSize: "16px", mb: 1 }}
        >
          {label}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: "14px" }}>
          <span style={{ fontWeight: "bold" }}>Gastados:</span>{" "}
          {getValue("creditos_gastados")}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: "14px" }}>
          <span style={{ fontWeight: "bold" }}>Disponibles:</span>{" "}
          {getValue("creditos_disponibles")}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: "14px" }}>
          <span style={{ fontWeight: "bold" }}>Desperdiciados:</span>{" "}
          {getValue("creditos_desperdiciados")}
        </Typography>
      </div>
    );
  }

  return null;
};
